import mimetype from 'mime-types';

export const getFileExtension = (fileName: string) => {
  const type = mimetype.contentType(fileName);

  if (!type) return fileName.split('.').pop();

  return mimetype.extension(type);
};
